import * as React from 'react';
import LegalPage from './sections/LegalPage';

export default function Terms() {
  return <LegalPage title="Terms of Service" fileUrl={`${process.env.PUBLIC_URL}/terms.pdf`} />;
}
